import type { UiNode } from "@ory/kratos-client";
import { getNodeLabel } from "./integrations/ui";

const dictionary: { [key: string]: string } = {
	ID: "Email",
	"Sign in with password": "Login",
	"Sign in with hardware key": "Use security key",
};

const translate = (text: string): string => {
	if (text in dictionary) return dictionary[text];
	return text;
};

export const translateInputText = (node: UiNode): string => {
	const text = node.meta.label?.text ?? "";
	return translate(text);
};

export const translateNodeLabel = (node: UiNode): string =>
	translate(getNodeLabel(node));

export const translateErrorMessage = (text: string): string => {
	const missingPattern = /^Property (.+ is missing\.)$/;
	return text.replace(missingPattern, "$1");
};
